import React from "react"
import { Col, Container, Row } from "react-bootstrap"
import DefaultLayout from "../../components/layout/DefaultLayout"
import { AmbassadorTable } from "../../components/ambassador/AmbassadorTable"

export const Ambassador = () => {
  return (
    <DefaultLayout>
      <Container>
        <Row>
          <Col>
            <h1>Ambassador</h1>

            <hr />
          </Col>
        </Row>
        <Row>
          <Col>
            <AmbassadorTable />
          </Col>
        </Row>
      </Container>
    </DefaultLayout>
  )
}
